<template>
  <div class="OfferCardContent" :class="[`gap-${gap}`]">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'OfferCardContent',
  props: {
    gap: {
      type: String,
      default: 'md',
      validator(value) {
        return ['sm', 'md'].includes(value)
      },
    },
  },
}
</script>

<style lang="scss">
.OfferCardContent,
.OfferCardContent * {
  box-sizing: border-box;
}
.OfferCardContent {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
  position: relative;

  &.gap-md {
    gap: 8px;
  }
  &.gap-sm {
    gap: 4px;
  }
}
</style>
